import { useEffect } from 'react'
import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import { RightChevronIcon } from '@/common/icons/arrows.tsx'
import { cn } from '@/common/utilities.ts'
import { useLayout } from '@/layouts/LayoutProvider.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useNavigate } from 'react-router-dom'
import { usePageHeader } from '@/layouts/PageHeaderProvider.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/storage/store.ts'
import { startSelectProgram } from '@/storage/programs/thunk.ts'
import { ProgramYearsProps } from '@/queries/program/schemas.ts'

export default function ProgramsPage() {
  const auth = useSelector((state: RootState) => state.auth)
  const { setTitle } = usePageHeader()
  const dispatch = useDispatch<AppDispatch>()
  const { programYears, programs, selectedProgramYear } = useSelector(
    (s: RootState) => s.programs
  )
  const { setDesktopNavOpen } = useLayout()
  const navigate = useNavigate()

  const handleProgramListClick = (year: ProgramYearsProps) => {
    setDesktopNavOpen(true)
    dispatch(
      startSelectProgram(
        programs.find((p) => p.id === year.global_program_id) ?? programs[0],
        year
      )
    )
    navigate(AppRoutePaths.dashboard.index)
  }

  useEffect(() => {
    if (auth?.user?.first_name) {
      setTitle(`Welcome back ${auth?.user?.first_name}`)
    }
  }, [programYears])

  useEffect(() => {
    if (selectedProgramYear) {
      navigate(AppRoutePaths.dashboard.index)
    }
  }, [selectedProgramYear])

  return (
    <>
      <Card className="mt-4">
        <CardHeader className="flex justify-left items-center text-md font-semibold py-4">
          <div>
            <h1 className="text-xl font-bold leading-none text-gray-900">
              Program List
            </h1>
            <div className="flex items-center gap-2 text-sm font-medium text-gray-500">
              Choose a program to view
            </div>
          </div>
        </CardHeader>
        <CardContent className="p-0 lg:p-0">
          {programYears.map((program, index) => (
            <div
              key={program.id}
              className={cn(
                'flex justify-between items-center hover:bg-gray-50 hover:cursor-pointer',
                index !== programYears.length - 1 && 'border-b border-gray-200'
              )}
              onClick={() => handleProgramListClick(program)}
            >
              <div className="flex items-center ">
                <div className="text-sm font-medium text-gray-900 p-4">
                  <div className="w-10 h-10 bg-primary-100 flex items-center justify-center rounded-full">
                    {program.global_state_id ?? ''}
                  </div>
                </div>
                <div className="border-l border-gray-200 p-4">
                  <div className="font-bold text-md text-gray-900">
                    {program.name}
                  </div>
                  <div className="font-semibold text-sm text-gray-500">
                    {/* {Boolean(program.enrolled_scholar_count) &&
                      `${program.enrolled_scholar_count} Enrolled`} */}
                  </div>
                  <div className="font-semibold block sm:hidden text-sm text-gray-500">
                    {''}
                  </div>
                </div>
              </div>
              <div className="flex items-center p-4">
                {/* <Badge
                  semanticColor={
                    program.enrollment_status ? 'Positive' : 'Notice'
                  }
                  className="hidden mr-6 my-1 sm:block"
                >
                  Enrollment {program.enrollment_status ? 'Open' : 'Closed'}
                </Badge> */}
                <RightChevronIcon className="text-lg" />
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </>
  )
}
